import React from "react";
import "./footer.css"
import { useNavigate } from "react-router";

const currentDate = new Date();

function INCSUBFooter(){
  
  const navigate = useNavigate( null)
  return (
    <div className="INCSUB_Footer">
      <div className="footerAbout">
        <p className="About"  style={{cursor: 'pointer'}}  onClick={() => navigate('/about-us')}> About Us </p>
        <p className="Privacy" style={{cursor: 'pointer'}} onClick={() => navigate('/terms')}>Terms & Conditions</p>
        <p className="Privacy" style={{cursor: 'pointer'}} onClick={() => navigate('/refund')}>Refund & Cancellation</p>
        <p className="Privacy" style={{cursor: 'pointer'}} onClick={() => navigate('/contact-us')}>Contact Us</p>
        <p className="About" style={{cursor: 'pointer'}} onClick={ () =>  window.open('/privacypolicy.html')} > Privacy Policy  </p>
      </div>
      <div className="line"></div>
      <div className="App-footer">
        <div className="copyright">
          <p>
            Copyright {currentDate.getFullYear()} @TheSubscription.in All Rights Reserved.
          </p>
        </div>
        <div className="Footer-text">
          <div className="INCSUBPowerby"><a href='https://www.incubators.town/' >{'Powered By'}</a></div>
          <div className="Inclogo">
            <a style={{ textDecoration: 'none' }} href='https://www.incubators.town/' >
            <img src={"/assets/images/incLogo.png"} className="logo" alt="logo" /></a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default INCSUBFooter;